import React,{useEffect} from 'react';
import { useTranslation } from 'react-i18next';

const ErrorPage = () => {
  const { t } = useTranslation('common');
  useEffect(() => {
    localStorage.removeItem('pendingSigner');
  }, []);
  return (
    <div>
      <div style={{ marginLeft: '10px', marginTop: '5%', textAlign: "center", fontSize: '25px', color: "Red" }}>
        <p>{t('error.errorMsg')}</p>
      </div>
    </div>
  );
};

export default ErrorPage;